import type { Filter } from "../../types/experiment";
import { getFilterTypeKey } from "../../types/experiment";
import { AlwaysFilter } from "./AlwaysFilter";
import { UserIdsFilter } from "./UserIdsFilter";
import { GuildIdsFilter } from "./GuildIdsFilter";
import { UserAgeRangeFilter } from "./UserAgeRangeFilter";
import { UserIdRangeFilter } from "./UserIdRangeFilter";
import { GuildIdRangeFilter } from "./GuildIdRangeFilter";
import { GuildMemberCountRangeFilter } from "./GuildMemberCountRangeFilter";
import { UserInGuildFilter } from "./UserInGuildFilter";
import { UserLocationFilter } from "./UserLocationFilter";
import { ClientLocationFilter } from "./ClientLocationFilter";
import { UserIpFilter } from "./UserIpFilter";
import { ClientIpFilter } from "./ClientIpFilter";
import { UserLocaleFilter } from "./UserLocaleFilter";
import { ClientLocaleFilter } from "./ClientLocaleFilter";
import { UserHasFlagFilter } from "./UserHasFlagFilter";
import { StaffFilter } from "./StaffFilter";
import { BotFilter } from "./BotFilter";
import { GuildHasFeatureFilter } from "./GuildHasFeatureFilter";
import { InstallationIdsFilter } from "./InstallationIdsFilter";
import { ClientReleaseChannelFilter } from "./ClientReleaseChannelFilter";
import { UnitIdInExperimentFilter } from "./UnitIdInExperimentFilter";
import { ClientVersionFilter } from "./ClientVersionFilter";
import { ClientOSFilter } from "./ClientOSFilter";
import { UnitIdInRangeByHashFilter } from "./UnitIdInRangeByHashFilter";
import { ClientSystemLocaleFilter } from "./ClientSystemLocaleFilter";
import { UserPremiumTypeFilter } from "./UserPremiumTypeFilter";
import { UnitIdMatchesFilterSnapshotFilter } from "./UnitIdMatchesFilterSnapshotFilter";
import type { ComponentType } from "react";

interface FilterComponentEntry {
  component: ComponentType<{ value: any; onChange: (value: any) => void }>;
}

const FILTER_REGISTRY: Record<string, FilterComponentEntry> = {
  always: { component: AlwaysFilter },
  user_ids: { component: UserIdsFilter },
  guild_ids: { component: GuildIdsFilter },
  user_age_range: { component: UserAgeRangeFilter },
  user_id_range: { component: UserIdRangeFilter },
  guild_id_range: { component: GuildIdRangeFilter },
  guild_member_count_range: { component: GuildMemberCountRangeFilter },
  user_in_guild: { component: UserInGuildFilter },
  user_location: { component: UserLocationFilter },
  client_location: { component: ClientLocationFilter },
  user_ip: { component: UserIpFilter },
  client_ip: { component: ClientIpFilter },
  user_locale: { component: UserLocaleFilter },
  client_locale: { component: ClientLocaleFilter },
  user_has_flag: { component: UserHasFlagFilter },
  staff: { component: StaffFilter },
  bot: { component: BotFilter },
  guild_has_feature: { component: GuildHasFeatureFilter },
  installation_ids: { component: InstallationIdsFilter },
  client_release_channel: { component: ClientReleaseChannelFilter },
  unit_id_in_experiment: { component: UnitIdInExperimentFilter },
  client_version: { component: ClientVersionFilter },
  client_os: { component: ClientOSFilter },
  unit_id_in_range_by_hash: { component: UnitIdInRangeByHashFilter },
  client_system_locale: { component: ClientSystemLocaleFilter },
  user_premium_type: { component: UserPremiumTypeFilter },
  unit_id_matches_filter_snapshot: { component: UnitIdMatchesFilterSnapshotFilter },
};

export function getFilterComponent(filter: Filter): ComponentType<{ value: any; onChange: (value: any) => void }> | null {
  const key = getFilterTypeKey(filter);
  return FILTER_REGISTRY[key]?.component ?? null;
}

export function getFilterData(filter: Filter): any {
  const key = getFilterTypeKey(filter);
  return (filter as any)[key];
}

export function setFilterData(filter: Filter, data: any): Filter {
  const key = getFilterTypeKey(filter);
  const negate = (filter as any).negate;
  return { ...filter, [key]: data, ...(negate !== undefined ? { negate } : {}) } as Filter;
}

export { FILTER_REGISTRY };
